import type { ComponentType } from 'react';
import { Building2, Cpu, Landmark, ShieldAlert, TrendingUp, Warehouse } from 'lucide-react';

type Icon = ComponentType<{ className?: string }>;

export type TeamMember = { name: string; role: string; credential: string };

// Leadership and advisors, as on the pitch deck.
export const executiveTeam: TeamMember[] = [
  { name: 'Anthony Caruso', role: 'CEO', credential: 'Former NJII IP Analyst; municipal and corporate consultant' },
  { name: 'Azeez Shaik', role: 'CPO', credential: 'Former NASA RockSat CS/AI Lead; AI researcher and IEEE reviewer' },
  { name: 'Thomas Gammer', role: 'CTO', credential: 'Former Bausch + Lomb AI Engineer; ML/AI solutions engineer' },
  { name: 'Sean Roche', role: 'Director of Development', credential: 'Education IT and organization-wide systems rollouts' },
  { name: 'Joshua Lanjwal', role: 'Technical Lead', credential: 'Backend and secure data systems engineer for regulated organizations' },
];

export const advisoryBoard: TeamMember[] = [
  { name: 'Gitanjali Singh', role: 'Regulations & Compliance Advisor', credential: 'Director of Regulatory Affairs @ AstraZeneca' },
  { name: 'Michael Sachs', role: 'Customer Success & Operations Advisor', credential: 'Customer Success @ Salesforce, AWS and Oracle' },
  { name: 'Mike Brzezinski', role: 'Hardware & Deployment Advisor', credential: 'Director of Cloud Sales @ AMD' },
  { name: 'Otima Bhanot', role: 'Marketing & Strategic Partnership Advisor', credential: 'Strategic Advisor @ EvolvX Strategy' },
];

export const initials = (name: string) => name.split(' ').map((part) => part[0]).join('');

export const whyNow: { icon: Icon; title: string; description: string }[] = [
  { icon: Cpu, title: 'Local models caught up',
    description: 'Open-weight models now rival frontier models on a single GPU, at a fraction of the cost.' },
  { icon: ShieldAlert, title: 'Breaches up, rules tighter',
    description: "Attacks keep rising and data rules keep tightening. Data that never leaves your walls can't be stolen in transit or harvested to decrypt later." },
  { icon: TrendingUp, title: 'Cloud AI prices are rising',
    description: 'Providers are passing data-center and compute costs on to customers. Hardware you own locks in your cost.' },
];

export const whoWeServe: { icon: Icon; title: string; points: string[] }[] = [
  { icon: Landmark, title: 'Local governments', points: [
    'Cities and counties with decades of records and strict data rules',
    'Newark City Hall runs our AI fully air-gapped today',
    'Every new city starts from a proven, trusted setup',
  ] },
  { icon: Building2, title: 'Mid-sized organizations', points: [
    'Firms with 50 to 499 people, decades of records and little IT staff',
    'Up and running in weeks',
    'Usually connected to the AI tools they already use',
  ] },
  { icon: Warehouse, title: 'Regulated enterprises', points: [
    'Defense, hospitals, banks, research and military labs',
    'Sites where nothing can leave the building',
    'Private models, archives and hardware, sized to the work',
  ] },
];
